export enum ExportStatus {
  PENDING = "PENDING",
  PROCESSING = "PROCESSING",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
}

export enum ExportType {
  NCDHHS_DATA = "NCDHHS_DATA",
  IRB_SURVEY = "IRB_SURVEY",
  TEEN_DATA = "TEEN_DATA",
  NON_IRB_SURVEY = "NON_IRB_SURVEY",
  USERS_TO_CONTACT = "USER_CONTACT",
  MERIDIAN_IL_DATA = "MERIDIAN_IL_DATA",
  ALL_MARKETS_DATA = "ALL_MARKETS_DATA",
  NJ_RHT_DATA = "NJ_RHT_DATA",
}

export interface ExportLog {
  id: string;
  export_type: ExportType;
  requested_by: string;
  requestedByUser?: {
    id: string;
    first_name: string;
    last_name: string;
    email: string;
  };
  status: ExportStatus;
  file_url: string | null;
  file_key: string | null;
  error_message: string | null;
  metadata: Record<string, unknown>;
  started_at: Date | null;
  completed_at: Date | null;
  created_at: Date;
  updated_at: Date;
}

export interface ExportHistoryResponse {
  success: boolean;
  exports: ExportLog[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    isLastPage: boolean;
  };
}

export interface ExportRequestResponse {
  success: boolean;
  message: string;
  exportId: string;
  status: ExportStatus;
}

export interface ExportByIdResponse {
  success: boolean;
  export: ExportLog;
}

// SSE Event Payloads
export interface ExportQueuedPayload {
  exportId: string;
  type: ExportType;
  status: ExportStatus;
}

export interface ExportStartedPayload {
  exportId: string;
  type: ExportType;
  status: ExportStatus;
}

export interface ExportProgressPayload {
  exportId: string;
  progress: number;
  message?: string;
}

export interface ExportCompletedPayload {
  exportId: string;
  type: ExportType;
  status: ExportStatus;
  fileUrl: string;
}

export interface ExportFailedPayload {
  exportId: string;
  type: ExportType;
  status: ExportStatus;
  error: string;
}
